import type { CreateJobRoleApiRequest } from "./../../../../apps/hr-portal/src/features/dashBoard/types";
export const buildCandidateFormData = (data: {
  name: string;
  email: string;
  phone: string;
  experience?: number | null;
  matchingScore: number;
  jobId: string;
  skills: string[];
  resume?: File;
}): FormData => {
  const formData = new FormData();
  formData.append("name", data.name);
  formData.append("email", data.email);
  formData.append("phone", data.phone);
  formData.append("experience", String(data.experience ?? ""));
  formData.append("matchingScore", String(data.matchingScore));
  formData.append("jobId", data.jobId);
  data.skills.forEach((skill) => formData.append("skills", skill));
  if (data.resume) {
    formData.append("resume", data.resume);
  }
  return formData;
};

export const buildJobRoleFormData = (
  data: Partial<CreateJobRoleApiRequest>,
): FormData => {
  const formData = new FormData();

  const basicFields: Array<keyof CreateJobRoleApiRequest> = [
    "jobTitle",
    "location",
    "jobDescription",
    "experienceLevel",
    "status",
    "extractionId",
  ];

  basicFields.forEach((field) => {
    const value = data[field];
    if (value !== undefined && value !== null) {
      formData.append(field, value as string);
    }
  });

  const jsonFields: Array<keyof CreateJobRoleApiRequest> = [
    "experienceRequired",
    "interviewDuration",
    "skills",
    "codingQuestion",
    "softSkillQuestion",
    "culturalQuestion",
    "dsaQuestion",
    "systemDesignQuestion",
  ];

  jsonFields.forEach((field) => {
    const value = data[field];
    if (value !== undefined && value !== null) {
      formData.append(field, JSON.stringify(value));
    }
  });

  const booleanFields: Array<keyof CreateJobRoleApiRequest> = [
    "askDsaQuestion",
    "askCodingQuestion",
    "askSoftSkillQuestion",
    "askCulturalQuestion",
    "askSystemDesignQuestion",
  ];

  booleanFields.forEach((field) => {
    const value = data[field];

    if (value !== undefined && value !== null) {
      // Send boolean value if provided
      formData.append(field, String(!!value));
    }
  });

  if (data.file) {
    formData.append("file", data.file);
  }

  return formData;
};
